export const iconFontAwesomeUsersPeoplePeoplePulling = (
	<i className="fa-solid fa-people-pulling"></i>
);
